if (!customElements.get('product-form')) {
  console.log("TESTING I AM LOADED")
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('.product__form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      /*this.cartNotification.setActiveElement(document.activeElement);*/

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (document.querySelector('#otpRadio:checked') != null) {
        /* Not subscribing */
        //delete formData['selling_plan']
        formData.delete('selling_plan');
      }

      /*formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));*/
      /*formData.append('sections_url', window.location.pathname);*/
      config.body = formData;
      pintrk('track', 'addtocart', {
        product_id: formData.get("id")
      });

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          console.log(response);

          //Get Cart Content
          fetch('/cart.js')
            .then((response) => response.json())
            .then((response) => {
         

              let itemCount = document.getElementById('item--count');
              let itemsInCart = response.item_count;
              let plural = 'items';
              let single = 'item';

              if (itemsInCart === 1) {
                itemCount.innerHTML = `${itemsInCart}  <span>${single}</span>`;
              } else if (itemsInCart === 0) {
                itemCount.innerHTML = `${itemsInCart}  <span>${plural}</span>`;
              } else {
                itemCount.innerHTML = `${itemsInCart}  <span>${plural}</span>`;
              }

              let giftWithPurchaseModule = document.getElementById('gwp');
              let items = response.items;
     
              items.filter((item) => {
                if (item.product_type === 'Free Product') {
                  giftWithPurchaseModule.style.display = 'none!important;'
                  return;
                }
              });
         
              reloadCart();
            })


          /*this.cartNotification.renderContents(response);*/
          // handle upsell
          let upsellForm = document.querySelector('.product__upsell-form');
          let upsellCheckbox = document.querySelector('.product__upsell-checkbox');
          if (upsellCheckbox != null && upsellCheckbox.checked) {
            const upsellData = new FormData(upsellForm);
            this.handleUpsell(upsellData);
          } else {
            reloadCart();
            openCart();
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    handleUpsell(upsellData) {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = upsellData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          reloadCart();
          openCart();
        })
        .catch((e) => {
          console.error(e);
        })
    }
  });
}

